import { DomainData } from "@/lib/api/domain-data";
import { DomainError } from "@/lib/api/domain-error";
import { AxiosRequestConfig } from "axios";
import { Result, ok, err } from "neverthrow";
import apiClient from "./api.client";

export async function request(
  config: AxiosRequestConfig,
): Promise<Result<DomainData, DomainError>> {
  try {
    const response = await apiClient.request(config);
    return ok(new DomainData({ data: response.data, status: response.status }));
  } catch (error: unknown) {
    const maybeAxiosError = error as any;
    const status = maybeAxiosError?.response?.status;
    const responseData = maybeAxiosError?.response?.data;
    const method = String(config.method || "GET").toUpperCase();
    const url = String(config.url || "");

    console.error("[request-api.client] request failed", {
      method,
      url,
      status,
      responseData,
      hasCookieHeader: Boolean(maybeAxiosError?.config?.headers?.Cookie),
      withCredentials: maybeAxiosError?.config?.withCredentials,
    });
    return err(new DomainError(error));
  }
}
